import { hasYesOrNo } from 'models/validate';
import { ValidateJSModel } from 'forms/shared/types';
import { PyschologicalCompetenceModel } from './types';
import psychologicalOrderTypeValidator from '../shared/orderTypeValidator';

const pyschologicalCompetenceValidator: ValidateJSModel<PyschologicalCompetenceModel> = {
  IsIncompetent: { presence: true, hasValue: { validator: hasYesOrNo } },

  List: (value, attributes) => {
    if (attributes?.IsIncompetent && attributes?.IsIncompetent.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: psychologicalOrderTypeValidator, requireDisposition: false },
      };
    }
    return {};
  },

  Comments: {},

  SummaryComments: {},
};

export default pyschologicalCompetenceValidator;
